import classNames from 'classnames';
import { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';

type PropsHtmlAnchor = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export type PropsPortalLink = {
  variant?:
    | 'default'
    | 'neutral'
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  underlineOnHover?: boolean;
} & Required<Pick<PropsHtmlAnchor, 'children'>> &
  Omit<PropsHtmlAnchor, 'children' | 'rel'>;

export function PortalLink({
  variant,
  underlineOnHover = false,
  children,
  className,
  ...restProps
}: PropsPortalLink) {
  return (
    <a
      {...restProps}
      rel="noopener noreferrer"
      className={classNames(
        {
          'text-vs-base-content': variant === 'default',
          'text-vs-neutral': variant === 'neutral',
          'text-vs-primary': variant === 'primary',
          'text-vs-secondary': variant === 'secondary',
          'text-vs-accent': variant === 'accent',
          'text-vs-info-focus': variant === 'info',
          'text-vs-success-focus': variant === 'success',
          'text-vs-warning-focus': variant === 'warning',
          'text-vs-error-focus': variant === 'error',
        },
        underlineOnHover ? 'hover:underline' : 'underline',
        'rounded',
        'focus:outline-vs-secondary focus:outline-offset-4 focus:outline focus:outline-2',
        className
      )}
    >
      {children}
    </a>
  );
}

export default PortalLink;
